import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Icon, Button, DropdownMenu, Chip } from '@arnsbogroup/react-voicearchive'
import useApi from 'hooks/useApi'
import classNames from 'classnames'
import MissingUploadsModal from './MissingUploadsModal'

export default ({ order, readOnly, refetch }) => {
  const [loading, setLoading] = useState(false)

  // Tasks the talent can never be paid for, plus the T.B.I. the coordinator
  // picked - held so the modal's "Invoice anyway" can resume where it left off.
  const [missingUploads, setMissingUploads] = useState(null)

  const [types,,, loadTypes] = useApi(`/rest/v2/tbi_possibilities?search[tbi]=1`, { load: false })

  const onSubmit = (tbi) => {
    const tbiName = types.find(({ uid }) => uid == tbi)?.name
    if (confirm(`Are you sure about your TBI option? (${tbiName})`)) {
      setLoading(true)
      const body = new FormData()
      body.append('orderid', order.uid)
      fetch(`/order/validateTbiChange.json`, { method: 'POST', body })
        .then((response) => response.json())
        .then(({ success, errors, meta }) => {
          setLoading(false)
          if (errors && !!errors.length && !confirm(errors.join(', '))) {
            return
          }
  
          // Once the order is invoiced and closed, nothing surfaces these again -
          // this is the last chance to catch them, so ask before continuing.
          const tasks = (meta && meta.tasksMissingUploads) || []
          if (tasks.length) {
            setMissingUploads({ tasks, tbi })
            return
          }
  
          invoiceOrder(tbi)
        })
        .catch((error) => toastr.error(error))
    }
  }

  const invoiceOrder = (tbi) => {
    setLoading(true)

    const body = new FormData()
    body.append('orderid', order.uid)
    body.append('tbi', tbi)

    fetch(`/order/tbiChange.json`, { method: 'POST', body })
      .then((response) => response.json())
      .then(({ success, errors, meta }) => {
        setLoading(false)

        if (success) {
          if (meta.skippedSync) {
            toastr.success('Scheduled for invoicing, but not yet invoiced')
          } else if (meta.emptyInvoice) {
            toastr.info('No tasks were eligible for invoicing. Skipping sync…')
          } else if (meta.paypalInvoiceCreated) {
            toastr.success('An invoice has been sent directly to the client with a link to pay via PayPal. You will be notified when the payment is received, so you can release the files')
          } else {
            toastr.success('Invoice created and synced')
          }

          return refetch()
        } else {
          toastr.error(errors.join(', '))
        }
      })
      .catch((error) => toastr.error(error))
  }

  return (
    <>
      <DropdownMenu
        button={{
          size: 'sm',
          disabled: readOnly || loading,
          onClick: loadTypes,
          children: (
            <span>Invoice (T.B.I.) {loading && <Icon icon="redo" className="animate-spin" />}</span>
          ),
        }}
        items={!types ? [{ children: 'Loading...' }] : types.map(({ uid, name }) => ({
          children: name,
          onClick: () => onSubmit(uid),
        })) || []}
      />

      {/* Only mounted while it is needed: Modal binds Esc unconditionally, and
          the order page is not somewhere to be swallowing that key. */}
      {!!missingUploads && (
        <MissingUploadsModal
          show
          tasks={missingUploads.tasks}
          onClose={() => setMissingUploads(null)}
          onConfirm={() => {
            const { tbi } = missingUploads
            setMissingUploads(null)
            invoiceOrder(tbi)
          }}
        />
      )}
    </>
  )
}
